export { contract_i_e_types_hash } from '@/views/business/fields.js'
export const money_collect = [
    {
      type: '应付',
      num_type: 'payable'
    },
    {
      type: '付款',
      num_type: 'payment'
    }, 
    {
      type: '计提',
      num_type: 'payment_accrual'
    }
  ]

  export const money_collect_income = [
    {
        type: '收款',
        num_type: 'received'
      }, 
      {
        type: '应收',
        num_type: 'receivable'
      }
  ]

